import React from 'react';
import TopicItem from './TopicItem';
import style from './Style.module.css';
import Skeleton from 'common/components/npm/skeleton/Skeleton';

const TopicList = ({ data }: { data: Category[] }) => {
  return (
    <section className='container pb-[3.4rem] md:pb-[5.2rem] xl:pb-[9rem]'>
      <div
        className={
          `mt-[7rem] grid grid-cols-2 gap-y-[3.3rem] md:mt-[8.3rem] 
      md:gap-[3.4rem] md:gap-y-[3.7rem] xl:mt-[12.7rem] xl:gap-[5rem] xl:gap-y-[5.3rem] xl:px-[6rem] ` +
          style['line2']
        }
      >
        {!data ? (
          [...Array(4)].map((_, index) => (
            <Skeleton
              key={index}
              containerClassName='col-span-2 md:col-span-1'
              className='h-[30rem] rounded-[1.8rem] xl:rounded-7'
            />
          ))
        ) : (
          <>{data?.map((item) => <TopicItem {...item} />)}</>
        )}
      </div>
    </section>
  );
};

export default TopicList;
